<div *ngIf="message" class="uk-flex">
	<div class="uk-card uk-card-default uk-card-body uk-width-large uk-margin-auto uk-margin-xlarge-bottom">
		<h3 class="uk-card-title uk-text-center uk-margin-medium-bottom">{{ message }}</h3>
		<p>Мы свяжемся с вами для уточнения деталей его реализации в ближайшее время</p>
		<p class="uk-flex uk-flex-between">
			<a class="uk-button uk-button-primary" routerLink="/">На главную</a>
			<a *ngIf="userService.user" class="uk-button uk-button-primary" routerLink="/personal-orders">Посмотреть все заказы</a>
		</p>
	</div>
</div>
